module.exports = __webpack_public_path__ + "static/media/encouraging-staff.9ad91a19.png";